module.exports = __webpack_public_path__ + "static/media/banner_bg_tutorials.65ad7f6b.png";